import React from 'react';
import { AlertTriangle, Mail, Phone } from 'lucide-react';

const AccountDisabled = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-gray-900 to-black flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-gradient-to-br from-gray-900/80 to-black/60 backdrop-blur-lg rounded-xl border border-gray-700 p-8 text-center">
        {/* Icon */}
        <div className="mb-6">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-red-500/10 border-2 border-red-500/20">
            <AlertTriangle className="h-10 w-10 text-red-400" />
          </div>
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold text-white mb-4">
          Account Disabled
        </h1>

        {/* Message */}
        <p className="text-gray-300 mb-6 leading-relaxed">
          Your CentsAhead account has been temporarily disabled. This may be due to a violation of our terms of service or for security reasons.
        </p>

        {/* Contact Information */}
        <div className="space-y-4 mb-8">
          <div className="text-sm text-gray-400">
            If you believe this is an error, please contact our support team:
          </div>
          
          <div className="flex items-center justify-center space-x-2 text-teal-400">
            <Mail className="h-4 w-4" />
            <span className="text-sm">support@centsahead.com</span>
          </div>
          
          <div className="flex items-center justify-center space-x-2 text-teal-400">
            <Phone className="h-4 w-4" />
            <span className="text-sm">1-800-CENTS-AHEAD</span>
          </div>
        </div>

        {/* Action Button */}
        <button
          onClick={() => window.location.href = '/'}
          className="w-full px-6 py-3 bg-gradient-to-r from-teal-600 to-teal-700 text-white font-medium rounded-lg hover:from-teal-700 hover:to-teal-800 transition-all duration-200 shadow-lg hover:shadow-xl"
        >
          Return to Login
        </button>

        {/* Footer */}
        <div className="mt-8 pt-6 border-t border-gray-700">
          <div className="flex items-center justify-center space-x-2">
            <div className="w-8 h-8 bg-gradient-to-r from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center">
              <span className="text-black font-bold text-sm">¢</span>
            </div>
            <span className="text-gray-400 text-sm font-medium">CentsAhead</span>
          </div>
          <p className="text-gray-500 text-xs mt-2">
            Financial wellness for everyone
          </p>
        </div>
      </div>
    </div>
  );
};

export default AccountDisabled;